import { Flex, Text, Spinner } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
export default function LargeLoadingSection({ minH = 32, text = "Loading...", fontSize, ...rest }) {
  return (
    <Flex justify="center" flexDir="column" align="center" minH={minH} {...rest}>
      <Spinner />
      <Text fontSize={fontSize ?? { base: "xl", md: "3xl" }} mt={4}>
        {text}
      </Text>
    </Flex>
  );
}
